import React from "react";
import { Label } from "semantic-ui-react";

const priorities = {
  low: "green",
  normal: "yellow",
  high: "orange",
  urgent: "red",
};

const Priority = ({ priority }) => (
  <Label basic color={priority ? priorities[priority] : null}>
    {priority}
  </Label>
);

export default Priority;



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/Priority.js